import { render } from "./delivery-to.vue?vue&type=template&id=f776126c"
import script from "./delivery-to.vue?vue&type=script&lang=js"
export * from "./delivery-to.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__